import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRoute from 'constants/apiRouting'
import {
  FETCH_PDF_REPORTS_TABLE_DATA,
  FETCH_PDF_REPORTS_TABLE_DATA_FAILURE,
  FETCH_PDF_REPORTS_TABLE_DATA_SUCCESS,
} from './reducer'

function* fetchPdfReportsTableData({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRoute.PDF_REPORTS_TABLE}${UrlHelper.getPsfsQuery({
        psfs: payload,
      })}`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_PDF_REPORTS_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_PDF_REPORTS_TABLE_DATA_FAILURE })
    }
  } catch (error) {
    yield put({ type: FETCH_PDF_REPORTS_TABLE_DATA_FAILURE })
    console.error('FETCH TRIGGER TABLE DATA FAILED:', error)
  }
}

function* pdfReportsSaga() {
  yield takeLatest(FETCH_PDF_REPORTS_TABLE_DATA, fetchPdfReportsTableData)
}

export default pdfReportsSaga
